import constants from '@/config/constants';
import { callApi } from '@/services/CallApi.service';

const getCountInOrg = async (accessToken) => {

    const options = {
        url: `${constants.api.baseUrl}/file/count`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};

const getList = async (accessToken, siteUid) => {

    const options = {
        url: `${constants.api.baseUrl}/file/list/${siteUid}`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};

const getBasicList = async (accessToken, siteUid) => {

    const options = {
        url: `${constants.api.baseUrl}/file/basic/list/${siteUid}`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};

const get = async (accessToken, fileUid, thumbnail) => {


    const options = {
        url: `${constants.api.baseUrl}/file/${fileUid}`,
        method: 'GET',
        responseType: 'blob',
    };

    const query = {
        thumbnail,
    };

    return await callApi(options, accessToken, false, query);
};

const getMeta = async (accessToken, fileUid) => {


    const options = {
        url: `${constants.api.baseUrl}/file/meta/${fileUid}`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};

const getBasicMeta = async (accessToken, fileUid) => {


    const options = {
        url: `${constants.api.baseUrl}/file/basic/meta/${fileUid}`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};

const update = async (accessToken, siteUid, formData) => {

    const options = {
        url: `${constants.api.baseUrl}/site/${siteUid}`,
        method: 'PATCH',
    };

    const body = {
        name: formData.name,
        logoUrl: formData.logoUrl,
        primaryColor: formData.primaryColor,
        secondaryColor: formData.secondaryColor,
    };

    return await callApi(options, accessToken, body);
};

const remove = async (accessToken, fileUid) => {

    const options = {
        url: `${constants.api.baseUrl}/file/${fileUid}`,
        method: 'DELETE',
    };

    return await callApi(options, accessToken);
};

export default {
    getCountInOrg,
    getList,
    getBasicList,
    get,
    getMeta,
    getBasicMeta,
    update,
    remove,
};
